import { basicInitialState } from '../_utils/basicInitialState';
import { TLoginState } from './loginModel';

export const loginInitialState: TLoginState = {
  ...basicInitialState,
  displayError: null
};
